export enum ColumnHeaders {
  BRAND = 'Brand',
  PRODUCT = 'Product',
  CATEGORY = 'Category',
  LOCATION = 'Location',
  CURRENT_QTY = 'Current',
  LOW_STOCK_QTY = 'Low stock',
  RESTOCK_QTY = 'Restock',
  QTY_TO_ORDER = 'Qty to order',
  COST = 'Cost',
}
